import { render, staticRenderFns } from "./CloseOpenProjectModal.vue?vue&type=template&id=4c6dee74&scoped=true"
import script from "./CloseOpenProjectModal.vue?vue&type=script&lang=js"
export * from "./CloseOpenProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6dee74",
  null
  
)

export default component.exports